<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br/><br/>
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">{{ title }}</div>
        <div>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>¿Mostrar Biografía en Perfil público?</td>
                  <td>
                    <v-switch
                      v-model="settings.showDescription"
                    ></v-switch>
                  </td>
                </tr>
                <tr>
                  <td>¿Mostrar fecha de nacimiento en Perfil público?</td>
                  <td>
                    <v-switch
                      v-model="settings.showNacimiento"
                    ></v-switch>
                  </td>
                </tr>
                <tr>
                  <td>¿Mostrar estado civil Perfil público?</td>
                  <td>
                    <v-switch
                      v-model="settings.showEstadoCivil"
                    ></v-switch>
                  </td>
                </tr>
                <tr>
                  <td>Quiero ver todas las publicaciones</td>
                  <td>
                    <v-switch
                      v-model="settings.showAll"
                    ></v-switch>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div v-if="!settings.showAll">
            <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text mt-10">Intereses</div>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="(category, index) in allCategories" :key="index" >
                    <td>{{ category.name }}</td>
                    <td>{{ category.tags }}</td>
                    <td>
                      <v-checkbox
                        v-model="selected"
                        :value="category.id"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <v-btn
            color="success"
            elevation="7"
            large
            @click="save()"
            >Guardar ajustes</v-btn
          >
        </div>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Nota",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    
  },

  data: () => ({
    title:"Configuración",
    settings:{},
    allCategories:[],
    selected:[]
  }),
  mounted() {
    this.$API
      .get({
        url: "alumno/getAlumno"
      }).then((res) => {
        console.log(res)
        this.settings=res.settings;
        this.selected = res.categories.map((v) => {return v.category_id})
        
      });
    this.$API
      .get({
        url: "publications-categories"
      }).then((res) => {
        this.allCategories=res;
       
        
      });
  },
  methods: {
    async save(){
      var formData = new FormData();
      formData.append('settings',JSON.stringify(this.settings));
      formData.append('categories', this.selected )
      
       await this.$API
        .post({
          url: "profile",
          data: formData
        }).then(res => {
            this.selected = res.categories.map((v) => {return v.category_id})
        });
    }
  }
};
</script>
